import { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import { withAppHOC } from '../../hoc';
import { StyledContentContainer } from '../../components/styled';
import PageHeader from '../../components/PageHeader/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import API from '../../api';
import { RESPONSE_STATUSES } from '../../constants';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

const StyledStatusContainer = styled.section`
  text-align: center;
  padding: 50px 0px;
`;

const StyledStatusIcon = styled.section`
  font-size: 50px;
  svg {
    &.blue {
      color: #0095ff;
    }
    &.green {
      color: forestgreen;
    }
    &.red {
      color: red;
    }
  }
`;

const StyledStatusHeading = styled.h1`
  font-size: 20px;
  font-weight: normal;
  margin: 10px 0px;
  padding: 0px;
  &.blue {
    color: #0095ff;
  }
  &.green {
    color: forestgreen;
  }
  &.red {
    color: red;
  }
`;

const StyledStatusMessage = styled.p`
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  margin: 0px;
  padding: 0px;
`;

const PaymentGatewayDepositsStatus = () => {
  const { id } = useParams();
  const [state, setState] = useState({
    isLoading: false,
    status: '',
    message: '',
  });

  const readData = useCallback(() => {
    setState((prevState) => ({ ...prevState, isLoading: true }));
    API.get(`/payments/payment-gateway-deposits-status/${id}`)
      .then((response) => {
        const { status, message } = response.data;
        setState((prevState) => ({ ...prevState, status, message }));
        setTimeout(() => {
          window.location.href = '/payments/payment-gateway-deposits';
        }, 5000);
      })
      .catch((error) => {
        setState((prevState) => ({
          ...prevState,
          status: RESPONSE_STATUSES.FAILED,
          message: error.message,
        }));
      })
      .finally(() => {
        setState((prevState) => ({ ...prevState, isLoading: false }));
      });
  }, [id]);

  useEffect(() => {
    readData();
  }, [readData]);

  const renderPageHeading = () => (
    <PageHeader
      title="Payment Gateway Deposit Status"
      showReloadData={false}
      showLoadButton={false}
    />
  );

  return (
    <>
      {renderPageHeading()}
      <StyledContentContainer graybackground="true">
        <StyledStatusContainer>
          {state.isLoading && <LoadingSpinner isLoading={state.isLoading} />}
          {!state.isLoading && (
            <>
              <StyledStatusIcon>
                <FontAwesomeIcon
                  icon={
                    state.status === RESPONSE_STATUSES.SUCCESS
                      ? faCircleCheck
                      : state.status === RESPONSE_STATUSES.FAILED
                      ? faCircleXmark
                      : faExclamationCircle
                  }
                  className={
                    state.status === RESPONSE_STATUSES.SUCCESS
                      ? 'green'
                      : state.status === RESPONSE_STATUSES.FAILED
                      ? 'red'
                      : 'blue'
                  }
                />
              </StyledStatusIcon>
              <StyledStatusHeading
                className={
                  state.status === RESPONSE_STATUSES.SUCCESS
                    ? 'green'
                    : state.status === RESPONSE_STATUSES.FAILED
                    ? 'red'
                    : 'blue'
                }
              >
                {state.status}
              </StyledStatusHeading>
              <StyledStatusMessage>{state.message}</StyledStatusMessage>
            </>
          )}
        </StyledStatusContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(PaymentGatewayDepositsStatus);
